import { render, staticRenderFns } from "./detailsWarranty.vue?vue&type=template&id=176d2a6b&scoped=true&"
import script from "./detailsWarranty.vue?vue&type=script&lang=js&"
export * from "./detailsWarranty.vue?vue&type=script&lang=js&"
import style0 from "./detailsWarranty.vue?vue&type=style&index=0&id=176d2a6b&lang=scss&scoped=true&"
import style1 from "./detailsWarranty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d2a6b",
  null
  
)

export default component.exports